export default {
  tabs: {
    home: 'Główna',
    menu: 'Menu',
    orders: 'Zamówienia',
  },
};
